$(function() {
    $('[data-calendar-historic').each(function() {
        // Get element
        var wrapper = this;

        // Variables
        var date = new Date();
        var year = date.getYear() + 1900;
        var div;
        
        // Create calendars
        var calendars = [];
        for (var i = 0; i < 12; i++) {
            // Create element
            div = document.createElement("div");
            div.className = "clean-theme";
            wrapper.appendChild(div);
            // Create month calender (we set the date to 0)
            calendars.push(
                jsCalendar.new(div, 0, {
                    zeroFill : true,
                    navigator : false,
                    language: $('html').attr('lang')
                })
            );
            calendars[i].goto("01-" + ((i + 1 < 10) ? "0" : "") + (i + 1) + "-" + year);
        }
    });
});